import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit'
import { Theme } from '@/theme'
import { authSlice } from '../auth/authSlice'
import { FeatureNames } from '../names'

import type { RootState } from '../../initStore'

interface ThemeState {
	theme: Theme
	colorIndex: number
}

// Get initial theme from localStorage
const getInitialTheme = (): Theme => {
	const savedTheme = localStorage.getItem('honeygrid-theme')
	if (savedTheme === Theme.Dark || savedTheme === Theme.Light) {
		return savedTheme
	}
	return Theme.Light
}

// Get initial color index from localStorage
const getInitialColorIndex = (): number => {
	const savedIndex = localStorage.getItem('honeygrid-color-index')
	return savedIndex ? parseInt(savedIndex) : 0
}

const initialState: ThemeState = {
	theme: getInitialTheme(),
	colorIndex: getInitialColorIndex(),
}

export const themeSlice = createSlice({
	name: FeatureNames.Theme,
	initialState,
	reducers: {
		setTheme: (state, action: PayloadAction<Theme>) => {
			state.theme = action.payload
			// Persist to localStorage
			localStorage.setItem('honeygrid-theme', action.payload)
		},
		setColorIndex: (state, action: PayloadAction<number>) => {
			state.colorIndex = action.payload
			// Persist to localStorage
			localStorage.setItem('honeygrid-color-index', action.payload.toString())
		},
	},
	extraReducers: (builder) => {
		builder.addCase(authSlice.actions.logOut, () => initialState)
	},
})

export const { setTheme, setColorIndex } = themeSlice.actions

// Selectors
export const themeSelector = (state: RootState) => state.theme.theme

export default themeSlice.reducer
